import BaseComponent from '../../base/base_component';
import Model from './free_play_component_model';
import * as FREE_PLAY_CONSTS from "./free_play_component_consts";
import FPVouchersComponentController from "./vouchers/fp_vouchers_component_controller";
import DOM from "../../utils/dom";
import Event from "../../utils/event";
import _ from '../../utils/underscore';
import { SYSTEM_EVENTS, USER_EVENTS } from "../../events/events";
import Device from "../../utils/device";
import FPGamesComponentController from "./games/fp_games_component_controller";
import { PRIORITY_LEVEL } from "../../services/overlay_manager/overlay_manager_levels";
import Strings from "../../utils/strings";
import ScreenLockComponent from "../screen_lock/screen_lock_component_controller";
import FreePlayComponentModel from './free_play_component_model';
import { IAlteredFreePlayVoucher } from './voucher/free_play_voucher_consts';

const containerView = require('./view/free_play_component.html');

export default class FreePlayComponentController extends BaseComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'FreePlayComponentController';


    /**
     * @static
     * @type {string}
     */
    static DIRECTIVE = 'cgp-directive-free_play';

    /**
     * Root component selector.
     *
     * @type {string}
     * @private
     */
    _selector = 'cgp-free-play-component';
    private _gamesContainer: FPGamesComponentController;
    private _vouchersContainer: FPVouchersComponentController;
    _model: FreePlayComponentModel;
    private _selectedVoucher: IAlteredFreePlayVoucher;
    private _modeSetup: any = {};

    init(params) {
        super.init(params);
        this._model = Model.create(params);
        this._initDirection();
        this._subscribe();
    }


    /**
     * Create element and inject vouchers to element HTML
     * @returns {FreePlayComponentController}
     */
    start() {
        const freePlayContainerHTML = this.bake(containerView);
        this.setHTML(freePlayContainerHTML);
        return this;
    }


    _subscribe() {
        this.onSystemEvent(SYSTEM_EVENTS.FREE_PLAY_VOUCHER_REMOVED, (voucher) => {
            this.logger.debug('Start remove voucher ' + voucher.ID + ' from component');
            this.onVoucherRemoved(voucher.ID);
        });

        this.onSystemEvent(SYSTEM_EVENTS.SCREEN_RESIZE_CHANGED, () => {
            // support device change only in PC
            // Change screen size in mobile is not relevant case. Also in mobile this event fired very frequently, so we don't want to handle this case
            // If component opened in light box in PC, then screen size doesn't affect to component view
            if (true === this._getIsMobileMode() || false === this.isDirective()) {
                return;
            }
            // we should handle only one case, affect on arrows in vertical mode
            if (this._vouchersContainer) {
                this._vouchersContainer.onSizeChanged();
            }
        });

        this.onSystemEvent(SYSTEM_EVENTS.SCREEN_CHANGE_STATE, () => {
            // change direction
            DOM.removeClass(this.getDOMElementByClassName(FREE_PLAY_CONSTS.FP_CSS_CLASSES.FP_CONTAINER), 'cgp-fp-games-active');
            this._initDirection(true);
            // recreate component light way
            this._updateDirection();
            this._updateModeStyle();
            this._removeContainers();
            this._createVouchersContainer();
            this.handleLock();

        });
    }


    handleLock() {
        // avoid execute logic in case that this directive is not exist on DOM, but has not removed by Directive component yet
        const directiveEl = this.getEl().parentElement.parentElement;
        if (!directiveEl) {
            return false;
        }

        // support orientation / device change
        if (this._getIsMobileMode() && !Device.isTablet() && !Device.isPortrait()) {
            const screenLock = ScreenLockComponent.create();
            screenLock.start();
            Event.fire(SYSTEM_EVENTS.OPEN_OVERLAY, {
                component: screenLock,
                priority: PRIORITY_LEVEL.LOCK,
                isCloseBtnAllowed: false,
                isHasHeader: false,
            });
            // lock screen
            return true;
        } else {
            Event.fire(SYSTEM_EVENTS.CLOSE_OVERLAY, { priority: PRIORITY_LEVEL.LOCK });
            return false;
        }
    }


    /**
     * Subscribe to back button
     * @private
     */
    private _subscribeUserEvents() {
        this.onDOMEvent(this.getDOMElementByClassName(FREE_PLAY_CONSTS.FP_CSS_CLASSES.BACK_BTN), USER_EVENTS.ON_CLICK, () => {
            this._onBackBtnClicked();
        });
    }


    /**
     * Handle back button click
     * @private
     */
    private _onBackBtnClicked() {
        DOM.removeClass(this.getDOMElementByClassName(FREE_PLAY_CONSTS.FP_CSS_CLASSES.FP_CONTAINER), 'cgp-fp-games-active');
        this._model.setLayoutState(FREE_PLAY_CONSTS.FP_LAYOUT_STATE.VOUCHERS);
        // case when voucher has been removed from game mode
        if (this._isNoVouchers()) {
            this._showNoRewards();
        }
    }


    /**
     * Handle voucher remove
     * @param voucherId
     * @private
     */
    onVoucherRemoved(voucherId) {
        const state = this._model.getLayoutState();
        const isGameMode = state === FREE_PLAY_CONSTS.FP_LAYOUT_STATE.GAMES && true === this._getLayoutByConfig('gamesLayout').hasBack;
        this._vouchersContainer.removeVoucher(voucherId, !isGameMode)
            .then((selectedVoucher?: IAlteredFreePlayVoucher, activeChanged?: boolean) => {
                if (selectedVoucher) {
                    this.onVoucherSelected(selectedVoucher, true);
                    return;
                }
                if (isGameMode) {
                    if (this._selectedVoucher && this._selectedVoucher.ID === voucherId) {
                        this._gamesContainer.disableComponent();
                    }
                } else {
                    if (this._isNoVouchers()) {
                        this._showNoRewards();
                    }
                }
                this._selectedVoucher = null;
            })
            .catch(() => {

            }
            );
    }


    /**
     * When voucher expired we should to disable game component for this voucher once it selected
     * @param voucherId
     */
    onVoucherExpired(voucherId) {
        if (this._selectedVoucher && this._selectedVoucher.ID === voucherId && this._gamesContainer) {
            this._gamesContainer.disableComponent();
        }
    }


    /**
     * Handle event when the component attached to DOM.
     * From this point the component is ready to execute DOM manipulation and calculations regarding to entire document
     */
    onAppendedToDOM() {
        super.onAppendedToDOM();
        // recreate all containers. This fix the issue when we're trying to recreate directives on oauth changed event.
        // In this case gamesContainer is already exists and it's not appended to DOM, so actually it won't be rerendered.
        this._vouchersContainer = null;
        this._gamesContainer = null;
        if (!this.serviceFactory.oAuth2Service().isAuthorized()) {
            this.logger.debug('User is not authorized. Unable to retrieve vouchers.');
            return;
        }
        this._subscribeUserEvents();
        this._updateDirection();
        this._updateModeStyle();
        this._createVouchersContainer();
        this.handleLock();
    }


    /**
     * Get classes to render in overlay
     * @returns {{additionalClasses: [string], contentAdditionalClasses: [string,string,string]}}
     */
    getOverlayClasses() {
        return {
            additionalClasses: ['cgp-fp-lightbox'],
            contentAdditionalClasses: ['cgp-theme-property-lb-corner-radius'],
        };
    }


    /**
     * Open voucher games
     * @param voucherId
     */
    onVoucherSelected(voucher: IAlteredFreePlayVoucher, activeChanged: boolean) {
        if (this._model.getGameTypeID()) {
            // if game exist, we need to open this game directly
            this.serviceFactory.gamesInformationService().getGamesInfo([this._model.getGameTypeID()])
                .then((mappedGames) => {
                    Object.keys(mappedGames).forEach((gameKey) => {
                        const game = mappedGames[gameKey];
                        this.openGame(Object.assign({ gameType: gameKey }, game), voucher);
                    });
                })
                .catch((error) => {
                    this.logger.error('GameTypeMapper failed. Unable to display voucher game list');
                    this.logger.error(error);
                });
        } else {
            // prevent handling voucher selection on click / touch by the user
            if (activeChanged === false && this._getLayoutByConfig('gamesLayout').hasBack === false) {
                return;
            }
            // prevent handling voucher selection on auto change
            if (activeChanged === true && this._getLayoutByConfig('gamesLayout').hasBack === true) {
                return;
            }

            DOM.addClass(this.getDOMElementByClassName(FREE_PLAY_CONSTS.FP_CSS_CLASSES.FP_CONTAINER), 'cgp-fp-games-active');
            this._model.setLayoutState(FREE_PLAY_CONSTS.FP_LAYOUT_STATE.GAMES);
            this._createGamesContainer(voucher)
                .then(() => {
                    if (this._isVoucherExpired(this._selectedVoucher)) {
                        this.onVoucherExpired(this._selectedVoucher.ID);
                    }
                });
        }
        this.sendAnalytics('SelectVoucher', { voucherID: voucher.ID });
    }


    /**
     * Handle game selection
     * @param gameTypeID
     * @param gameTitle
     */
    onGameSelected(gameTypeID: number, gameTitle: string) {
        this.openGame({
            gameType: gameTypeID,
            title: gameTitle
        }, this._selectedVoucher);
    }


    /**
     * Open voucher game
     * @param gameData
     */
    openGame(gameData: {
        gameType: number,
        title: string}, voucher) {
        this._handleOpenGameRestrictions()
            .then(() => {
                this.sendAnalytics('OpenGame', { gameID: gameData.gameType });
                if (!gameData || !voucher) {
                    return;
                }

                this.logger.debug('Start opening voucher game ' + gameData.gameType + ' from voucher ' + voucher.ID);

                this.serviceFactory.gameService().openRealGame({
                    gameType: gameData.gameType,
                    gameName: gameData.title,
                    freePlayData: {
                        freePlayId: voucher.ID * 1,
                        freePlayType: voucher.FreePlayTypeId * 1,
                        isThirdParty: voucher.CompanyID ? true : false,
                        freePlayOriginalAmount: voucher.OriginAmount,
                    }
                });

                if (false === this.isDirective()) {
                    Event.fire(SYSTEM_EVENTS.CLOSE_OVERLAY, {
                        el: this.getEl(),
                        priority: this._model.getOpenPriority() || PRIORITY_LEVEL.FP
                    });
                }
            })
            .catch(() => {
                this.logger.debug('Opening voucher' + gameData.gameType + ' from voucher ' + voucher.ID + 'game has been restricted by the user or additional logic');
            });

    }


    /**
     * Allow or avoid opening game process
     * @returns {*}
     * @private
     */
    private _handleOpenGameRestrictions() {
        const allowGameFn = this._model.getAllowOpenGame();
        if (allowGameFn && _.isFunction(allowGameFn)) {
            return allowGameFn();
        } else {
            return Promise.resolve();
        }
    }


    /**
     * Send GA
     * @param action
     */
    sendAnalytics(action: string, params) {
        let analyticsObj = this._model.getAnalytics()[action];
        if (analyticsObj) {
            // deep copy
            analyticsObj = Object.assign({}, analyticsObj);
            Object.keys(analyticsObj).forEach((key) => {
                const string = new Strings(analyticsObj[key]);
                const curly = string.getCurlyBracesBinding();
                if (curly.length > 0 && curly[0].to !== '' && params[curly[0].to]) {
                    analyticsObj[key] = analyticsObj[key].replace('{' + curly[0].to + '}', params[curly[0].to]);
                }
            });
            Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, analyticsObj);
        }
    }


    /**
     * Return true if the device is mobile and not table
     * @private
     */
    private _getIsMobileMode() {
        return Device.isMobileByOS();
    }



    /**
     * Set default direction (if not provided from client) according to device type
     * @private
     */
    private _initDirection(skipDefault = false) {
        let direction = this._model.getDirection();
        // In Mobile it's not supported because over complexity in orientation change
        if (!this._getIsMobileMode()) {
            // if direction is defined and mode is PC, this definition can override default mode
            if (direction && skipDefault === false) {
                return;
            }
            if (true === this.isDirective()) { // PC directive is vertical
                direction = FREE_PLAY_CONSTS.DIRECTION.VERTICAL;
            } else {
                direction = FREE_PLAY_CONSTS.DIRECTION.HORIZONTAL;
            }
        } else { // is mobile
            // in mobile there is no matter whether component is directive or not. Direction depends on device orientation only.
            // Vertical for Portrait and Horizontal for Landscape
            direction = Device.isPortrait() || Device.isTablet() ? FREE_PLAY_CONSTS.DIRECTION.VERTICAL : FREE_PLAY_CONSTS.DIRECTION.HORIZONTAL;
        }

        this._model.setDirection(direction);
    }


    /**
     * Create games container (once)
     * @param games
     * @private
     */
    private _createGamesContainer(voucher) {
        // Create container
        const games = voucher.games;
        if (!this._gamesContainer) {
            this._gamesContainer = FPGamesComponentController.create({
                direction: this._getLayoutByConfig('gamesLayout').direction,
                games: games,
                container: this,
                fpType: voucher.FreePlayTypeId
            }).start();
            this.innerComponentsRef.push(this._gamesContainer);
            // Attach to DOM
            DOM.append(this.getDOMElementByClassName(FREE_PLAY_CONSTS.FP_CSS_CLASSES.GAMES_CONTAINER), this._gamesContainer.getEl());
            return this._gamesContainer.onAppendedToDOM()
                .then(() => {
                    this._selectedVoucher = voucher;
                })
                .catch(() => {
                    // this._showNoRewards();
                });
        } else {
            return this._gamesContainer.updateGames(games, voucher.FreePlayTypeId)
                .then(() => {
                    this._selectedVoucher = voucher;
                });
        }

    }

    /**
     * 
     * @param date
     * @returns true if specified date is invalid
     * @private
     */
    private _isDateInvalid(date) {
        return !date || !_.isNumber(date.getTime());
    }

    /**
     * Check if voucher is already expired
     * @param voucher
     * @returns {boolean}
     * @private
     */
    private _isVoucherExpired(voucher) {
        if (this._isDateInvalid(voucher.ExpirationDate)) {
            return false; // NO ExpirationDate means that voucher not expired - fallback for old platform API (US)
        }

        const timeToLeft = new Date(voucher.ExpirationDate).getTime() - new Date().getTime();
        return !(timeToLeft > 0);
    }


    /**
     * Create VouchersContainerComponent and attache it to voucher container DOM element
     * @private
     */
    private _createVouchersContainer() {
        // Create container
        this._vouchersContainer = FPVouchersComponentController.create({
            scrollingOptions: this._getLayoutByConfig('vouchersLayout').scrollingOptions,
            vouchers: this._model.getVouchers(),
            container: this,
            title: this._getVoucherContainerTitle()
        }).start();
        this.innerComponentsRef.push(this._vouchersContainer);
        // Attach to DOM
        DOM.append(this.getDOMElementByClassName(FREE_PLAY_CONSTS.FP_CSS_CLASSES.VOUCHERS_CONTAINER), this._vouchersContainer.getEl());
        this._vouchersContainer.onAppendedToDOM()
            .then(() => {
                this._onVoucherContainerCreated();
            })
            .catch(() => {
                this._showNoRewards();
            });
    }


    /**
     * Get voucher container title source (from GameFrame or regular)
     * @returns {*}
     * @private
     */
    private _getVoucherContainerTitle() {
        const languageService = this.serviceFactory.languageService();
        return this._model.getGameTypeID()
            ? languageService.translation('free_play_message_selected_game_title')
            : languageService.translation('free_play_message_voucher_title');
    }

    private _onVoucherContainerCreated() {
        Event.fire(SYSTEM_EVENTS.FREE_PLAY_VOUCHER_MSG_OPENED, this._vouchersContainer.getVouchers());
        // if games layout rendered with vouchers layout, we should open games for the first voucher automatically
        if (!this._model.getGameTypeID() && false === this._getLayoutByConfig('gamesLayout').hasBack) {
            this.onVoucherSelected(this._vouchersContainer.getVouchers()[0], true);
        }
    }


    /**
     * Get direction by mode, voucher or games
     * @param mode
     * @returns {*}
     * @private
     */
    private _getLayoutByConfig(mode) {
        const direction = this._model.getDirection();
        const device = this._getIsMobileMode() ? 'mobile' : 'pc';
        const layoutConfig = this._model.getLayoutConfig();
        const directionLayoutConfig = layoutConfig[device][direction][mode];
        if (this._model.getGameTypeID() && directionLayoutConfig.gameMode) { // from game mode
            return directionLayoutConfig.gameMode;
        } else {
            return directionLayoutConfig;
        }
    }


    private _updateDirection() {
        DOM.removeClass(this.getEl(), FREE_PLAY_CONSTS.FP_CSS_CLASSES.DIRECTION_PREFIX + FREE_PLAY_CONSTS.DIRECTION.HORIZONTAL);
        DOM.removeClass(this.getEl(), FREE_PLAY_CONSTS.FP_CSS_CLASSES.DIRECTION_PREFIX + FREE_PLAY_CONSTS.DIRECTION.VERTICAL);
        DOM.addClass(this.getEl(), FREE_PLAY_CONSTS.FP_CSS_CLASSES.DIRECTION_PREFIX + this._model.getDirection());
    }


    private _updateModeStyle() {
        const fpContainer = this.getDOMElementByClassName(FREE_PLAY_CONSTS.FP_CSS_CLASSES.FP_CONTAINER);
        const isVouchersOnly = this._model.getGameTypeID();
        if (this._modeSetup) {
            DOM.removeClass(fpContainer, this._modeSetup.vouchersListClass);
            DOM.removeClass(fpContainer, this._modeSetup.gamesListClass);
            DOM.removeClass(fpContainer, this._modeSetup.hasBackClass);
        } else {
            this._modeSetup = {};
        }
        const direction = this._model.getDirection();
        const device = this._getIsMobileMode() ? 'mobile' : 'pc';
        const layoutConfig = this._model.getLayoutConfig();
        const vouchersLayout = layoutConfig[device][direction]['vouchersLayout'];
        const gamesLayout = layoutConfig[device][direction]['gamesLayout'];

        this._modeSetup.vouchersListClass = 'cgp-fp-vouchers-list-' + vouchersLayout.direction;
        DOM.addClass(fpContainer, this._modeSetup.vouchersListClass);
        this._modeSetup.gamesListClass = 'cgp-fp-games-list-' + gamesLayout.direction;
        DOM.addClass(fpContainer, this._modeSetup.gamesListClass);
        this._modeSetup.hasBackClass = gamesLayout.hasBack === true ? 'cgp-fp-has-back' : 'cgp-fp-no-has-back';
        DOM.addClass(fpContainer, this._modeSetup.hasBackClass);
        if (isVouchersOnly) {
            DOM.addClass(fpContainer, 'cgp-fp-gameframe-mode');
        }
    }



    /**
     * Get if there is no active vouchers
     * @returns {boolean}
     * @private
     */
    private _isNoVouchers() {
        const vouchers = this._vouchersContainer.getVouchers();
        return !vouchers || vouchers.length === 0;
    }


    /**
     * Show no free plays message
     * @private
     */
    private _showNoRewards() {
        DOM.addClass(this.getDOMElementByClassName(FREE_PLAY_CONSTS.FP_CSS_CLASSES.FP_CONTAINER), 'cgp-fp-vouchers-list-no-reward');
    }


    private _removeContainers() {
        if (this._vouchersContainer) {
            this._vouchersContainer.shutDown();
            DOM.removeElement(this.getDOMElementByClassName(FREE_PLAY_CONSTS.FP_CSS_CLASSES.VOUCHERS_CONTAINER), this._vouchersContainer.getEl());
            this._vouchersContainer = null;
        }
        if (this._gamesContainer) {
            this._gamesContainer.shutDown();
            DOM.removeElement(this.getDOMElementByClassName(FREE_PLAY_CONSTS.FP_CSS_CLASSES.GAMES_CONTAINER), this._gamesContainer.getEl());
            this._gamesContainer = null;
        }

    }

}
